export const APP_NAME = "SFM tools";
export const APP_URL = "https://sfmtools.com/";
export const APP_LOGO = "/logo.png";
export const FILE_PLACEHOLDER_THUMB = "/img/pdf-placeholder.jpg";
export const THEME_PRIMARY_COLOR = "#007c64";
